import dayjs from "dayjs";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { logOut } from "../redux/features/authSlice";

export const useCheckLoginStatus = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const checkLoginStatus = () => {
    const storedCred = localStorage.getItem("cred");

    if (storedCred) {
      const parsedCred = JSON.parse(storedCred);
      const currentDate = dayjs().format("YYYY-MM-DD");

      if (parsedCred.loginTimeStamp) {
        const credDate = dayjs(parsedCred.loginTimeStamp).format("YYYY-MM-DD");

        if (credDate === currentDate) {
          const currentTime = dayjs().format("HH:mm:ss");
          if (credDate != currentDate) {
            dispatch(logOut());
            enqueueSnackbar("Token expired...! Please login...", {
              variant: "error",
            });
            setInterval(() => {
              localStorage.removeItem("cred");
              window.location.href = "/auth/login";
            }, 300);

            return false;
          }
          return true;
        }
      }
    }

    enqueueSnackbar("Token expired...!", { variant: "error" });
    dispatch(logOut());
    localStorage.removeItem("cred");
    window.location.href = "/auth/login";

    return false;
  };

  return checkLoginStatus;
};
